module.exports = __webpack_public_path__ + "img/message.b5079a47.svg";